import React from 'react';
import { CheckIcon, FuelIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { Countdown } from './ui/Countdown';
import { checkoutUrl, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
const assurances = ['7-day guarantee', 'Secure payment', 'Instant access', 'Teach Oil & Gas with confidence starting today'];
export function FinalCta() {
  return <section className="bg-green-950 py-16 sm:py-20" aria-labelledby="final-title" data-id="element-74" data-mp="1jbty7qhfqydt">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-75" data-mp="1ed0kpy25f7dn">
        <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[.16em] text-amber-400" data-id="element-76" data-mp="1t2yd6q742j8n">
          <FuelIcon className="h-4 w-4" aria-hidden="true" data-id="element-77" data-mp="1o43hino1p074" /> {productShortName}
        </p>
        <h2 id="final-title" className="mx-auto mt-5 max-w-2xl text-balance text-3xl font-extrabold text-stone-50 sm:text-4xl" data-id="element-78" data-mp="223d1lyfdgegd">
          Created by Oil &amp; Gas education specialists, for educators worldwide
        </h2>

        <Countdown className="mt-8" data-id="element-79" data-mp="n6e4zlw4ghwd" />

        <div className="mt-8 flex flex-col gap-5 rounded-xl bg-stone-50 p-6 text-left shadow-2xl shadow-black/30 sm:flex-row sm:items-center sm:justify-between" data-id="element-80" data-mp="n7fdpjpo0sax">
          <p data-id="element-81" data-mp="x2qus8ojqblu">
            <b className="block text-sm uppercase leading-tight text-green-950" data-id="element-82" data-mp="x2zas9fytx19">{productShortName}</b>
            <span className="text-sm text-stone-600" data-id="element-83" data-mp="123n10swde9uf">
              {totalVolumes} volumes + {totalBonuses} bonuses · Instant access
            </span>
          </p>
          <div className="shrink-0 sm:text-right" data-id="element-84" data-mp="1b31kv9i17m5y">
            <p className="text-sm text-stone-600" data-id="element-85" data-mp="1b1qgb7griads">
              <span className="mr-2 line-through" data-id="element-86" data-mp="1fu04oj28b2dy">{priceBefore}</span>
              <b className="text-base text-green-900" data-id="element-87" data-mp="1ktd2fyun1tvb">{price}</b>
            </p>
            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" size="sm" className="mt-2" data-id="element-88" data-mp="1kvfpqb4ep8wc">
              Get my teacher ready now
            </Button>
          </div>
        </div>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-green-100" data-id="element-89" data-mp="1tryinncn0wsx">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-90" data-mp="3lwdmyiowqh64">
              <CheckIcon className="h-4 w-4 text-amber-400" aria-hidden="true" data-id="element-91" data-mp="3hcsbeg0p70w" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}